import React from "react";
const SvgBBiconsHandlebar = props => (
    <svg viewBox="0 0 154.11 20" {...props}>
        <g>
            <path d="M140.69,20H13.42C7.14,20,2.05,15.52,2.05,10S7.14,0,13.42,0H140.69c6.28,0,11.36,4.48,11.36,10S147,20,140.69,20Z"/>
        </g>
    </svg>
);

export default SvgBBiconsHandlebar;